
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { Calendar, Users, Heart, Bookmark, Plane, LayoutDashboard, Bell, Settings, User, UsersRound } from "lucide-react";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  const groups = [
    { 
      name: "Dashboard", 
      path: "/dashboard",
      icon: LayoutDashboard,
      color: "bg-blue-100"
    },
    { 
      name: "My Calendar", 
      path: "/calendar",
      icon: Calendar,
      color: "bg-pastel-yellow"
    },
    { 
      name: "Friends", 
      path: "/friends",
      icon: Users,
      color: "bg-pastel-blue"
    },
    { 
      name: "Family", 
      path: "/family",
      icon: Heart,
      color: "bg-pastel-red"
    },
    { 
      name: "Hobby", 
      path: "/hobby",
      icon: Bookmark,
      color: "bg-pastel-green"
    },
    { 
      name: "Holidays", 
      path: "/holidays",
      icon: Plane,
      color: "bg-pastel-purple"
    },
  ];

  return (
    <aside className="hidden md:block w-64 border-r border-gray-200 h-[calc(100vh-4rem)] sticky top-16 overflow-y-auto p-4">
      <h2 className="text-lg font-semibold mb-4">Groups</h2>
      <div className="space-y-1">
        {groups.map((group) => (
          <Button
            key={group.name}
            variant={isActive(group.path) ? "default" : "ghost"}
            className={`w-full justify-start ${isActive(group.path) ? "bg-gray-100 text-gray-900" : ""}`}
            onClick={() => navigate(group.path)}
          >
            <div className={`p-1 rounded-md mr-2 ${group.color}`}>
              <group.icon className="w-4 h-4 text-gray-900" />
            </div>
            {group.name}
          </Button>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-gray-200">
        <h2 className="text-lg font-semibold mb-4">Personal</h2>
        <div className="space-y-1">
          <Button
            variant={isActive("/notifications") ? "default" : "ghost"}
            className={`w-full justify-start ${isActive("/notifications") ? "bg-gray-100 text-gray-900" : ""}`}
            onClick={() => navigate("/notifications")}
          >
            <div className="p-1 rounded-md mr-2 bg-gray-100">
              <Bell className="w-4 h-4 text-gray-900" />
            </div>
            Notifications
          </Button>
          
          <Button
            variant={isActive("/friends-and-family") ? "default" : "ghost"}
            className={`w-full justify-start ${isActive("/friends-and-family") ? "bg-gray-100 text-gray-900" : ""}`}
            onClick={() => navigate("/friends-and-family")}
          >
            <div className="p-1 rounded-md mr-2 bg-gray-100">
              <UsersRound className="w-4 h-4 text-gray-900" />
            </div>
            Friends & Family
          </Button>
          
          <Button
            variant={isActive("/profile") ? "default" : "ghost"}
            className={`w-full justify-start ${isActive("/profile") ? "bg-gray-100 text-gray-900" : ""}`}
            onClick={() => navigate("/profile")}
          >
            <div className="p-1 rounded-md mr-2 bg-gray-100">
              <User className="w-4 h-4 text-gray-900" />
            </div>
            Profile
          </Button>
          
          <Button
            variant={isActive("/settings") ? "default" : "ghost"}
            className={`w-full justify-start ${isActive("/settings") ? "bg-gray-100 text-gray-900" : ""}`}
            onClick={() => navigate("/settings")}
          >
            <div className="p-1 rounded-md mr-2 bg-gray-100">
              <Settings className="w-4 h-4 text-gray-900" />
            </div>
            Settings
          </Button>
          
          <Button
            variant="outline"
            className="w-full justify-start mt-4 text-primary border border-primary"
            onClick={() => navigate("/dashboard")}
          >
            <div className="p-1 rounded-md mr-2">
              <LayoutDashboard className="w-4 h-4 text-primary" />
            </div>
            Back to Dashboard
          </Button>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
